<script lang="ts">
import Vue, { CreateElement, RenderContext, VNode } from 'vue';

import ConfirmationDialog from '@/bundles/Common/components/ConfirmationDialog.vue';

interface IProps {
  value: boolean;
  loading: boolean;
  label: string;
}

export default Vue.extend({
  name: 'ArchiveConfirmationDialog',

  functional: true,

  props: {
    value: Boolean,
    loading: Boolean,
    label: { type: String, required: true },
  },

  render (h: CreateElement, { props, listeners }: RenderContext<IProps>): VNode {
    return h(ConfirmationDialog, {
      props: {
        value: props.value,
        loading: props.loading,
      },
      on: listeners,
    }, [
      h('v-alert', {
        props: {
          dense: true,
          type: 'warning',
          icon: 'mdi-alert-outline',
        },
        class: 'ma-0',
      }, `Are you sure you want to archive this ${props.label}?`),
    ]);
  },
});
</script>
